// import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import Banner from "./Banner";
const Future = dynamic(() => import("./future"), { ssr: true });
const Milestone = dynamic(() => import("./milestone"), { ssr: true });
const WhatWe = dynamic(() => import("./whatwedo"), { ssr: true });
const Serve = dynamic(() => import("./serve"), { ssr: true });
const HowWeWork = dynamic(() => import("./howwework"), { ssr: true });
const Numbers = dynamic(() => import("./numbers"), { ssr: true });
const Promises = dynamic(() => import("./promises"), { ssr: true });
const Visionary = dynamic(() => import("./visonary"), { ssr: true });
const Explore = dynamic(() => import("./explore-career"), { ssr: true });
const Work = dynamic(() => import("./work"), { ssr: true });

interface RequestProposalProps {
  blocks?: any;
  isMobile?: boolean;
  breadcrumbs?: any;
}

const AboutUS = ({
  blocks,
  breadcrumbs,
  isMobile,
}: RequestProposalProps) => {
  return (
    <>
      <div className="nome-new rfp_new bg-one">
        {blocks?.map((block: any, i: number) => {
          switch (block?.__component) {
            case "blocks.2025-about-us-banner":
              return <Banner key={i} data={block} breadcrumbs={breadcrumbs} isMobile={isMobile} />;
            case "blocks.enterprise-future":
              return <Future key={i} data={block} />;
            case "blocks.milestones-that-define-us":
              return <Milestone key={i} data={block} />;
            case "blocks.what-we-do":
              return <WhatWe key={i} data={block} />;
            case "blocks.industries-we-serve":
              return <Serve key={i} data={block} />;
            case "blocks.how-we-work":
              return <HowWeWork key={i} data={block} />;
            case "blocks.t-roo-tech-in-numbers":
              return <Numbers key={i} data={block} />;
            case "blocks.our-promises":
              return <Promises key={i} data={block} />;
            case "blocks.visionary-leadership":
              return <Visionary key={i} data={block} />;
            case "blocks.impact-beyond-work":
              return <Work key={i} data={block} isMobile={isMobile} />;
            case "blocks.what-matters":
              return <Explore key={i} data={block} />;
            default:
              return (
                <div
                  key={i}
                  className="text-red-500 p-4 bg-red-50 border border-red-200 rounded-md mt-4 max-w-[1500px] mx-auto"
                >
                  Unknown block type: {block?.__component || "undefined"}
                </div>
              );
          }
        })}
      </div>
    </>
  );
};

export default AboutUS;
